import React, { useState } from 'react';
import {
  useStripe,
  useElements,
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  LinkAuthenticationElement,
  PaymentElement
} from "@stripe/react-stripe-js";
import styles from "./style.module.css"
import { connect, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import axios from 'axios'
import { toast, ToastContainer } from 'react-toastify';
import { BreathAPIs } from '../APIs/BreathAPIs';
import { addAmount } from '../Actions/Auth';
import { ButtonCustom } from '../BootstrapComponents/ButtonCustom';
import { Checkbox } from 'antd';
import { useEffect } from 'react';
import { PiWarningCircleBold } from "react-icons/pi";
import TooltipView from '../Dashboard/components/AdminDashboard/TooltipView';



const CardPaymentForm = ({setPaymentModal, jwt, balance, autopay, walletRechargeModal, noOfMethods, autopayThreshold}) => {
console.log('in card block profile...',autopay, autopayThreshold, noOfMethods)

  const [cardInfo, setCardInfo] = useState({
    last4: "",
    brand: "",
    exp_month: "",
    exp_year: ""
});
console.log('Conditoin2121,,',Math.round(Math.round(balance < 5 ? (autopayThreshold - balance) : 1) * 100))
    const [amount, setAmount] = useState(balance < 5 ? (autopayThreshold - balance) : 1); // Default to 1 dollar or deficient amount
    const [paymentOptionAmount, setPaymentOptionAmount] = useState(balance < 5 ? (autopayThreshold - balance) : 1);
    const stripe = useStripe();
    const elements = useElements();

    const [isLoading, setIsLoading] = useState(false);

    const [autoPay, setAutoPay] = useState(true) //have to set based on user db
    const [paymentMethod, setPaymentMethod] = useState('')
    const [paymentFormCollapsed, setPaymentFormCollapsed] = useState(true)
    const [enablePay, setEnablePay] = useState(true)
    const [payemntType, setPaymentType] = useState('')
    const dispatch = useDispatch();

    const options = {
    mode: 'payment',
    // paymentMethodOrder: ['amazon_pay','card'],
    currency: 'usd',
    // wallets: {
    //   applePay:(autoPay || saveCard) ? 'never' : 'always',
    //   googlePay:(autoPay || saveCard) ? 'never' : 'always'
    // },
    amount: Math.round(paymentOptionAmount * 100), // Convert to cents
    setup_future_usage: 'off_session',
    // payment_method_types : (autoPay || saveCard) ? ['card'] : []

  }

  useEffect(()=> {
    console.log("auto pay threshold change: ", autopayThreshold)
    console.log("updating amount to : ", Math.round((balance < 5 ? (autopayThreshold - balance) : 1) * 100))
    setAmount(balance < 5 ? (autopayThreshold - balance) : 1)
    setPaymentOptionAmount(balance < 5 ? (autopayThreshold - balance) : 1)
    elements.update({
      amount: Math.round((balance < 5 ? (autopayThreshold - balance) : 1) * 100),
    })
  }, [autopayThreshold])

  useEffect(() => {
    // console.log("autopay threshold updated: ", autopayThreshold)
    console.log("amount updated; ", amount, Math.round(amount * 100))
    elements.update({
      amount: Math.round(amount * 100),
    })
  }, [amount])
  
    

    const handleError = (error) =>{
      // console.log(error);
      toast.error(error);
    }
    function formatStripeError(errorString) {
      // Replace underscores with spaces
      let formattedString = errorString.replace(/_/g, ' ');
      formattedString = formattedString.charAt(0).toUpperCase() + formattedString.slice(1);
      return formattedString
    }

    const addToTransactionHistory = async(amount, status, type) =>{
      // console.log("need to add in trans his")
      setIsLoading(true);
      const res = await BreathAPIs.createTransactionHistory({
        dateEpoch: Math.floor(new Date().getTime()/1000.0), // epoch value in GMT need to convert it into zone base 
        amount: amount,
        status: status,
        type: type
      })
      setIsLoading(false);
      // console.log(res.data)
    }
    const updateWalletCoins =(amount)=>{
      dispatch(addAmount(amount));
      // console.log(res)
      // const res = await BreathAPIs.updateWalletCoins(jwt, amount);
      
      // console.log(res.data)
      // console.log(res)
      // return res; 
    }
    
    const handleSubmit = async (event) => {
      setIsLoading(true)
        event.preventDefault();

        if (!stripe || !elements) {
          return; // Stripe.js has not loaded yet. Make sure to disable form submission until Stripe.js has loaded.
      }
    try {
      const userWalletDetails = await BreathAPIs.getAmount(jwt)

      

    if ((parseFloat(userWalletDetails.data.walletCoins) + parseFloat(amount)) > userWalletDetails.data.maxLimit){
      alert(`Maximum amount in wallet should not exceed ${userWalletDetails.data.maxLimit}`)
      setIsLoading(false)
      return  
    }
    
        const {error: submitError} = await elements.submit();
          if (submitError) {
            // console.log("submitError", submitError)
            // console.log("error", error)
          toast.error(formatStripeError(submitError.code));
          setIsLoading(false)
          return;
          }
          // console.log("Amount to add",amount)
          
            let amountInCents = amount * 100;

            // console.log("userWalletDetails.data.walletCoins", userWalletDetails.data.walletCoins)
            
            if(userWalletDetails.data.walletCoins < 5){
              console.log("Inside if")
              amountInCents = (autopayThreshold - userWalletDetails.data.walletCoins) * 100;
              if(amountInCents < 50){
                amountInCents = 100; // in case amount is less than 50 cents amount will be set to 1 dollar
              }
              setAmount(amountInCents/100)
              setPaymentOptionAmount(amountInCents/100)
              
            }else{
              setAmount(1)
              amountInCents=100
              setPaymentOptionAmount(1)
            }

            console.log("amountInCents", amountInCents)

            const res = await BreathAPIs.addToWallet(amountInCents, jwt, autoPay)
            
            console.log(res);
            const clientSecret = res.data.paymentIntent.client_secret;
            const customerId = res.data.paymentIntent.customer
            
            //const {client_secret: clientSecret} = await res.json();
            //const clientSecret = 'pk_test_51MgMVRAPmgE2jEzZNLL7fojhCo052rXCR634fbmKPaVZL3lM1kM4QtRUWU6RvFl2BmQMeDBucOpgQDuDBV0lJ9ov00PmEkcwVC'
            const {error} = await stripe.confirmPayment({
              elements,
              clientSecret,
              confirmParams: {
                return_url: process.env.REACT_APP_BASE_URL,
              },
              // Uncomment below if you only want redirect for redirect-based payments
               redirect: "if_required",
            });
          
            if (error) {
              //handleError(error);
              // console.log(error);
              toast.error(formatStripeError(error.code));
              setIsLoading(false)
            }
            else {

              const stripePaymentMethods = await BreathAPIs.getStripePaymentMethods(jwt,'')
              console.log("stripePaymentMethods",stripePaymentMethods)
              const res_profile =  await BreathAPIs.updateProfile({isAutoPayEnabled:true, selectedPaymentMethod: stripePaymentMethods.data.methodList[0].id})
              
              updateWalletCoins(amountInCents/100)
              toast.success("Auto Pay Enabled Successfully")
              addToTransactionHistory(amountInCents/100, "success", "Credit")
              setPaymentModal(false)
              setIsLoading(false)
            }

        } catch (error) {
          console.log("Error in submiting payment", error)
          toast.error("Something went wrong while processing the payment. Please try again.")
          setIsLoading(false)
        }
        }
 
      console.log(autoPay)

    const onPaymentElementChange = async (e) => {
    console.log("payment element change", e)
    console.log("payment element change",e.value.type)
    setPaymentType(e.value.type)
    setAmount(balance < 5 ? (autopayThreshold - balance) : 1)
    setPaymentOptionAmount(balance < 5 ? (autopayThreshold - balance) : 1)
    // setPaymentFormCollapsed(e.collapsed)
    // await checkAutoPayConditions(e.value.type)

  }
      
    return (
      <div className={styles.formContainer}>
        {/* <div className={`${noOfMethods === 0 ? styles.hidePaymentSelectionSingleCard : styles.hidePaymentSelection}`}>
            Enter Card Details
        </div> */}
        <ToastContainer></ToastContainer>



      {/* <CardUI cardInfo={{cvv:123, cardNumber:24242342424, name:"Batman", expiry:'24/23'}}></CardUI> */}

         <form onSubmit={handleSubmit}>
            

          <PaymentElement
            onChange={(e) =>
              onPaymentElementChange(e)}
              options={options}
          ></PaymentElement>
          
         
          <div className={styles.validationAmountInfo}>
          $1 will be debited for validation, or the wallet will be topped up to reach ${autopayThreshold} if the balance is below $5
          </div>
          <div className='mt-4'>
            <ButtonCustom type="submit" text={isLoading ? "Loading...." : 'Enable Auto Pay'} disabled={!stripe || isLoading || !enablePay || (payemntType!=='card' && payemntType!=='apple_pay') } isLoading={isLoading} style={{ width: "100%" }} />
          </div>
            {/* <button type="submit" disabled={!stripe || isLoading} className={`${styles.payButton} btn btn-primary mt-2`}>
                {isLoading ? "Loading...." : 'Pay'}
            </button> */}
        </form> 
    </div>
    );
}

CardPaymentForm.propTypes={ 
  jwt: PropTypes.string,
  balance : PropTypes.number,
  autopay: PropTypes.bool,
  // autopayThreshold: PropTypes.number,
}

const mapStateToProps = state =>({
  balance: state.auth && state.auth.user ? state.auth.user.wallet.coins: null,
  jwt: state.auth  ? state.auth.token: null,
  autopay: state.auth && state.auth.user ? state.auth.user.isAutoPayEnabled : false,
  // autopayThreshold: state.auth && state.auth.user ? state.auth.user.autoPayThreshold : 20,
})

export default connect(mapStateToProps,{})(CardPaymentForm);
